module.exports = __webpack_public_path__ + "media/img/google-icon-c17879dc3e282d40dff49232c5d8ca3b.png";